import * as go from 'gojs/release/go-module';

import {
  LinkCategory,
  LinkLabelCategory,
  NodeCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { DiagramGraphObject } from 'src/containers/ProjectDiagram/types/diagram';
import {
  LinkData,
  Model,
  NodeData,
} from 'src/containers/ProjectDiagram/types/model';
import { TooltipData } from 'src/containers/ProjectDiagram/types/tooltip';
import { isLinkLabel } from 'src/containers/ProjectDiagram/utils/graphObject';
import { getDiagramObjectLabel } from 'src/containers/ProjectDiagram/utils/labels';

const getTooltippablePart = (obj: go.GraphObject): go.Part | null => {
  if (isLinkLabel(obj)) {
    return obj;
  }

  return obj.part || null;
};

export const showTooltip =
  (setTooltip: (data: TooltipData) => void): NonNullable<go.HTMLInfo['show']> =>
  (obj, diagram, _tool) => {
    const part = getTooltippablePart(obj);
    const data = part?.data as NodeData | LinkData | undefined;
    if (!part || !data) {
      return;
    }

    const text =
      data.category === NodeCategory.RESOURCE ||
      data.category === LinkCategory.MAPPING ||
      data.category === LinkLabelCategory.MAPPING_LABEL
        ? data.text
        : getDiagramObjectLabel(
            (diagram.model as Model).modelData.labelsByIri,
            part as DiagramGraphObject
          );

    if (!text) {
      return;
    }

    const { x: left, y: top } = diagram.transformDocToView(
      part.getDocumentPoint(go.Spot.TopLeft)
    );
    const { x: right, y: bottom } = diagram.transformDocToView(
      part.getDocumentPoint(go.Spot.BottomRight)
    );

    const width = right - left;
    const height = bottom - top;

    setTooltip({
      text,
      rect: {
        top,
        left,
        width,
        height,
      },
    });
  };

export const hideToolTip =
  (
    setTooltip: (data: TooltipData | null) => void
  ): NonNullable<go.HTMLInfo['hide']> =>
  (_diagram, _tool) => {
    setTooltip(null);
  };
